import React, { useEffect, useState } from "react";
import { Modal, Col, Row, Accordion, Table } from "react-bootstrap";
import { roleDetailsApi } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { DATE_FORMAT } from "helpers/common";
import { FadeLoader } from "react-spinners";
import styled from "styled-components";

export default function ViewRoleModal({ show, handleClose, id }) {
  const { loading } = useSelector(({ Permission }) => Permission);
  const [data, setData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const fetchData = () => {
    dispatch(
      roleDetailsApi({
        data: { _id: id },
        callBack: (err, response) => {
          const detail = response?.data;
          if (detail?._id) {
            setData(detail);
            console.info("Role data ------->", detail);
          }
        },
      }),
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold">Role Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <FadeLoader />
          </div>
        ) : (
          <AccordionSec className="section">
            <Accordion defaultActiveKey="0" className="w-100">

              <Accordion.Item eventKey="0" className="border rounded mb-3">
                <Accordion.Header className="fw-bold text-dark p-0">
                  Details
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Role Name</p>
                      <p>{data?.roleName || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Status</p>
                      <p className={data?.status === "active" ? "text-success fw-bold" : "text-danger fw-bold"}>
                        {data?.status || "--"}
                      </p>
                    </Col>

                    <Col lg={12} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Description</p>
                      <p>{data?.description || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Admin Name</p>
                      <p>{data?.adminDetails?.name || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Admin Email</p>
                      <p>{data?.adminDetails?.email || "--"}</p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Created At</p>
                      <p>
                        {data?.createdAt ? DATE_FORMAT(data?.createdAt) : "--"}
                      </p>
                    </Col>

                    <Col lg={6} sm={12} className="my-2">
                      <p className="mb-0 font-weight-bold">Modified At</p>
                      <p>
                        {data?.updatedAt ? DATE_FORMAT(data?.updatedAt) : "--"}
                      </p>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="border rounded mb-3">
                <Accordion.Header className="fw-bold text-dark p-0">
                  Permissions
                </Accordion.Header>
                <Accordion.Body>
                  {data?.permissions?.length > 0 ? (
                    <Table responsive bordered hover className="mb-0">
                      <thead>
                        <tr>
                          <th>Module</th>
                          <th>Action</th>
                          <th>Permission Key</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.permissions.map((perm) => (
                          <tr key={perm._id}>
                            <td>{perm?.module || "--"}</td>
                            <td className="text-capitalize">{perm?.action || "--"}</td>
                            <td>{perm?.permissionKey || "--"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <p className="text-muted text-center mb-0">No permissions assigned.</p>
                  )}
                </Accordion.Body>
              </Accordion.Item>

            </Accordion>
          </AccordionSec>
        )}
      </Modal.Body>
    </Modal>
  );
}

const AccordionSec = styled.div`
 .accordion-header{
  .accordion-button {
   background: transparent;
  }
 }
`;